
import {
  STORE_CustomerDefaultAddress,
  STORE_CustomerName,
  STORE_CSID,
  SECRET_KEY,
  STORE_Cart,
  STORE_CartCheckoutData,
  STORE_CSP,
  STORE_dtoCustomerAddressList,
  STORE_HardReleaseVersion,
  STORE_PAGE_URL,
  STORE_PRODUCT_LIST,
  STORE_PROMO_PRODUCT_LIST,
  STORE_PROMOTIONS,
  STORE_SHEDULEDateNTime,
  STORE_SelectedMerchant,
  STORE_SelectedMerchantProduct,
  ENTRY_MODE,
  CODE,
  MID,
  STORE_Addons,
  STORE_FinaleSelelctCartMerchantNZone,
  STORE_PhoneNo,
  TABLE_NO,
  TEMP_STORE_CSID,
  TEMP_STORE_CustomerName,
  TEMP_STORE_OTP,
  TEMP_STORE_PhoneNo,
} from "../database/store-names";
import {
  ENCRYPT_STORAGE_SESSION,
  ENCRYPT_STORAGE,
  SET_STARTUP,
} from "../config/config";
import {
  SET_VALUES_FROM_STORE_ON_START,
  GET_SET_STORED_DATA,
  GET_CSP,
} from "../database/get-stored-data";
import { GET_CART_COUNT, KEY_GENERATOR } from "../functions/funtion";
import { REQUEST_DEEPLINK } from "../functions/mobile-intigrator";
import { VALIDATE_CSP } from "../config/csp";
import { CLEAR_STORE } from "../database/clear-store";
import { Routes } from "react-router-dom";
import ProfileStack from "./stack/profile-stack";
import GroceryStack from "./stack/grocery-stack";
import OrdersStack from "./stack/order_stack";
import HomeStack from "./stack/home_stack";
import CartStack from "./stack/cart_stack";
import React from "react";

const PERSISTED_DT_QR_STATE_KEY = "PERSISTED_DT_QR_STATE";
const DT_QR_SECRET_KEY = "abc1234";
const QR_AUTH_CONTEXT_KEY = "QR_AUTH_CONTEXT";

const normalizeQrMid = (value) =>
  String(value || "")
    .trim()
    .replace(/^mid=/i, "");

const normalizeQrTableNo = (value) => String(value || "").trim();

const readQrAuthContext = () => {
  try {
    const rawValue = window.localStorage.getItem(QR_AUTH_CONTEXT_KEY);
    return rawValue ? JSON.parse(rawValue) : null;
  } catch (_error) {
    return null;
  }
};

const persistQrAuthContext = (context) => {
  try {
    window.localStorage.setItem(QR_AUTH_CONTEXT_KEY, JSON.stringify(context));
  } catch (_error) {}
};

const clearQrAuthContext = () => {
  try {
    window.localStorage.removeItem(QR_AUTH_CONTEXT_KEY);
  } catch (_error) {}
};

const clearQrTabState = () => {
  [
    ENTRY_MODE,
    SECRET_KEY,
    MID,
    TABLE_NO,
    CODE,
    STORE_PRODUCT_LIST,
    STORE_PROMO_PRODUCT_LIST,
    STORE_SelectedMerchant,
    STORE_SelectedMerchantProduct,
    STORE_PAGE_URL,
    STORE_CartCheckoutData,
  ].forEach((key) => {
    ENCRYPT_STORAGE.removeItem(key);
  });
};

const clearCustomerSessionForQrContextChange = () => {
  ENCRYPT_STORAGE.removeMultipleItems([
    STORE_CSID,
    STORE_PhoneNo,
    STORE_CustomerName,
    STORE_dtoCustomerAddressList,
    STORE_CustomerDefaultAddress,
    TEMP_STORE_CSID,
    TEMP_STORE_PhoneNo,
    TEMP_STORE_CustomerName,
    TEMP_STORE_OTP,
    STORE_Cart,
    STORE_CartCheckoutData,
    STORE_Addons,
    STORE_FinaleSelelctCartMerchantNZone,
    STORE_PROMOTIONS,
    STORE_SHEDULEDateNTime,
    STORE_SelectedMerchant,
    STORE_SelectedMerchantProduct,
    STORE_PRODUCT_LIST,
    STORE_PROMO_PRODUCT_LIST,
    STORE_PAGE_URL,
  ]);
};

const shouldResetQrCustomerSession = ({ csp, entryMode, mid }) => {
  const normalizedEntryMode = String(entryMode || "")
    .trim()
    .toUpperCase();
  const normalizedCsp = String(csp || "")
    .trim()
    .toUpperCase();
  const normalizedMid = normalizeQrMid(mid);

  if (normalizedEntryMode !== "QR" || normalizedCsp === "" || normalizedMid === "") {
    return false;
  }

  const currentContext = readQrAuthContext();
  if (!currentContext) {
    return false;
  }

  return (
    String(currentContext.csp || "")
      .trim()
      .toUpperCase() !== normalizedCsp ||
    normalizeQrMid(currentContext.mid) !== normalizedMid
  );
};

const decodeBase64 = (payload) => {
  if (!payload || !payload.trim()) {
    return null;
  }
  try {
    return atob(payload);
  } catch (error) {
    return null;
  }
};

const hasVersionValue = (value) =>
  value !== undefined &&
  value !== null &&
  String(value).trim() !== "" &&
  String(value).trim() !== "undefined";

const readPersistedDtQrState = () => {
  try {
    const rawValue = window.sessionStorage.getItem(PERSISTED_DT_QR_STATE_KEY);
    if (!rawValue) {
      return null;
    }

    const parsedValue = JSON.parse(rawValue);
    const csp = String(parsedValue?.csp || "")
      .trim()
      .toUpperCase();
    const entryMode = String(parsedValue?.entryMode || "")
      .trim()
      .toUpperCase();
    const secretKey = String(parsedValue?.secretKey || "").trim();
    const mid = String(parsedValue?.mid || "").trim();
    const tableNo = String(parsedValue?.tableNo || "").trim();

    if (
      csp !== "DT" ||
      entryMode !== "QR" ||
      secretKey !== DT_QR_SECRET_KEY ||
      mid === ""
    ) {
      return null;
    }

    return {
      csp,
      entryMode,
      secretKey,
      mid,
      tableNo,
    };
  } catch (_error) {
    return null;
  }
};

const persistDtQrState = ({ csp, entryMode, secretKey, mid, tableNo }) => {
  const payload = {
    csp: String(csp || "")
      .trim()
      .toUpperCase(),
    entryMode: String(entryMode || "")
      .trim()
      .toUpperCase(),
    secretKey: String(secretKey || "").trim(),
    mid: String(mid || "").trim(),
    tableNo: String(tableNo || "").trim(),
  };

  if (
    payload.csp !== "DT" ||
    payload.entryMode !== "QR" ||
    payload.secretKey !== DT_QR_SECRET_KEY ||
    payload.mid === ""
  ) {
    return;
  }

  window.sessionStorage.setItem(
    PERSISTED_DT_QR_STATE_KEY,
    JSON.stringify(payload),
  );
};

const shouldRestoreQrEntryMode = () => {
  const pathname = String(window.location.pathname || "").trim();
  const csp = String(ENCRYPT_STORAGE.getItem(STORE_CSP) || "")
    .trim()
    .toUpperCase();
  const secretKey = String(ENCRYPT_STORAGE.getItem(SECRET_KEY) || "").trim();
  const mid = String(ENCRYPT_STORAGE.getItem(MID) || "").trim();
  const isQrRoute =
    pathname.startsWith("/qr-list/") ||
    pathname.startsWith("/product-list/") ||
    pathname.startsWith("/product/") ||
    pathname.startsWith("/cart");

  return (
    csp === "DT" &&
    isQrRoute &&
    secretKey === "abc1234" &&
    mid !== ""
  );
};

export default class Rootes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      IsReady: false,
      IsLoading: true,
    };
  }

  async componentDidMount() {
    ENCRYPT_STORAGE.removeItem("MerChantData");
    const rawSearch = window.location.search || "";
    const pathname = String(window.location.pathname || "").trim();
    const directQrRouteMatch = pathname.match(
      /^\/qr-list\/([^/?#]+)(?:\/([^/?#]+))?/i,
    );
    const directQrMid = directQrRouteMatch
      ? normalizeQrMid(decodeURIComponent(directQrRouteMatch[1]))
      : "";
    const directQrTableNo = directQrRouteMatch
      ? normalizeQrTableNo(decodeURIComponent(directQrRouteMatch[2] || ""))
      : "";

    if (directQrMid !== "") {
      if (
        shouldResetQrCustomerSession({
          csp: "DT",
          entryMode: "QR",
          mid: directQrMid,
        })
      ) {
        clearCustomerSessionForQrContextChange();
      }
      clearQrTabState();
      ENCRYPT_STORAGE.setItem(STORE_CSP, "DT");
      ENCRYPT_STORAGE.setItem(ENTRY_MODE, "QR");
      ENCRYPT_STORAGE.removeItem("FROM");
      ENCRYPT_STORAGE.setItem(SECRET_KEY, DT_QR_SECRET_KEY);
      ENCRYPT_STORAGE.setItem(MID, directQrMid);
      ENCRYPT_STORAGE.setItem(TABLE_NO, directQrTableNo === "" ? 0 : directQrTableNo);
      persistDtQrState({
        csp: "DT",
        entryMode: "QR",
        secretKey: DT_QR_SECRET_KEY,
        mid: directQrMid,
        tableNo: directQrTableNo,
      });
      persistQrAuthContext({
        csp: "DT",
        entryMode: "QR",
        mid: directQrMid,
      });
      window.location.replace(`/startup/dt${window.location.hash || ""}`);
      return;
    }

    const persistedDtQrState = readPersistedDtQrState();
    if (persistedDtQrState && !rawSearch.includes("?QR?")) {
      ENCRYPT_STORAGE.setItem(ENTRY_MODE, "QR");
      ENCRYPT_STORAGE.removeItem("FROM");
      ENCRYPT_STORAGE.setItem(SECRET_KEY, persistedDtQrState.secretKey);
      ENCRYPT_STORAGE.setItem(MID, persistedDtQrState.mid);
      ENCRYPT_STORAGE.setItem(
        TABLE_NO,
        normalizeQrTableNo(persistedDtQrState.tableNo) === ""
          ? 0
          : normalizeQrTableNo(persistedDtQrState.tableNo),
      );
      ENCRYPT_STORAGE.setItem(STORE_CSP, persistedDtQrState.csp);
    }
    const legacyEntryMode = ENCRYPT_STORAGE.getItem("FROM");
    let entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
    if (
      (entryMode === undefined || entryMode === null || entryMode === "") &&
      legacyEntryMode !== undefined &&
      legacyEntryMode !== null &&
      legacyEntryMode !== ""
    ) {
      ENCRYPT_STORAGE.setItem(ENTRY_MODE, legacyEntryMode);
      ENCRYPT_STORAGE.removeItem("FROM");
    }
    entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
    if (
      (entryMode === undefined || entryMode === null || entryMode === "") &&
      shouldRestoreQrEntryMode()
    ) {
      ENCRYPT_STORAGE.setItem(ENTRY_MODE, "QR");
      ENCRYPT_STORAGE.removeItem("FROM");
      persistDtQrState({
        csp: ENCRYPT_STORAGE.getItem(STORE_CSP),
        entryMode: "QR",
        secretKey: ENCRYPT_STORAGE.getItem(SECRET_KEY),
        mid: ENCRYPT_STORAGE.getItem(MID),
        tableNo: ENCRYPT_STORAGE.getItem(TABLE_NO),
      });
    }
    await REQUEST_DEEPLINK();
    let capturedQuery = null;
    let hardReleaseVersion = ENCRYPT_STORAGE.getItem(STORE_HardReleaseVersion);
    hardReleaseVersion = hasVersionValue(hardReleaseVersion)
      ? String(hardReleaseVersion).trim()
      : undefined;
    if (rawSearch.startsWith("?")) {
      const queryPayload = rawSearch.substring(1);
      const queryParts = queryPayload.split("?").filter(Boolean);
      const searchParams = new URLSearchParams(rawSearch);
      const legacyVersionPart = queryParts.find((part) =>
        part.toLowerCase().startsWith("ver="),
      );
      const requestedVersion =
        searchParams.get("ver") ||
        searchParams.get("Ver") ||
        (legacyVersionPart ? legacyVersionPart.substring(4) : "");
      if (hasVersionValue(requestedVersion)) {
        hardReleaseVersion = requestedVersion.trim();
      }

      const Mode = (searchParams.get("mode") || queryParts[0] || "").toUpperCase();
      const secretKey = searchParams.get("secretKey") || queryParts[1];
      const mid = searchParams.get("mid") || queryParts[2];
      const tableNo = searchParams.get("tableNo") || queryParts[3];
      const code = searchParams.get("code") || queryParts[4];
      
      if (Mode === "QR") {
        if (
          shouldResetQrCustomerSession({
            csp: pathname.replace("/", ""),
            entryMode: Mode,
            mid,
          })
        ) {
          clearCustomerSessionForQrContextChange();
        }
        capturedQuery = {
          from: Mode,
          secretKey,
          mid,
          tableNo,
          code,
        };
        clearQrTabState();
      }

      const cleanUrl = window.location.pathname + window.location.hash;
      window.history.replaceState({}, document.title, cleanUrl);
    }

    let url = window.location.pathname;
    let IdentifyCspInUrl = await VALIDATE_CSP(url.replace("/", ""));
    let StoreCsp = await GET_CSP();
    const persistCSP = async () => {
      ENCRYPT_STORAGE.setItem(STORE_CSP, url.replace("/", ""));
      if (hasVersionValue(hardReleaseVersion)) {
        ENCRYPT_STORAGE.setItem(STORE_HardReleaseVersion, hardReleaseVersion);
      }
      await SET_STARTUP({
        csp: url.replace("/", ""),
        HardReleaseVersion: hardReleaseVersion,
      });
    };
    const applyCapturedQuery = () => {
      if (!capturedQuery) {
        return;
      }
      ENCRYPT_STORAGE.setItem(ENTRY_MODE, capturedQuery.from);
      ENCRYPT_STORAGE.removeItem("FROM");
      if (capturedQuery.secretKey) {
        const decodedSecret = decodeBase64(capturedQuery.secretKey);
        if (decodedSecret === DT_QR_SECRET_KEY) {
          ENCRYPT_STORAGE.setItem(SECRET_KEY, decodedSecret);
        } else {
          ENCRYPT_STORAGE.removeItem(SECRET_KEY);
        }
      }
      if (capturedQuery.mid) {
        ENCRYPT_STORAGE.setItem(MID, normalizeQrMid(capturedQuery.mid));
      }
      if (capturedQuery.tableNo !== undefined && capturedQuery.tableNo !== null) {
        const normalizedTableNo = String(capturedQuery.tableNo || "").trim();
        ENCRYPT_STORAGE.setItem(
          TABLE_NO,
          normalizedTableNo === "" ? 0 : normalizedTableNo,
        );
      } else {
        ENCRYPT_STORAGE.setItem(TABLE_NO, 0);
      }
      if (capturedQuery.code) {
        ENCRYPT_STORAGE.setItem(CODE, capturedQuery.code);
      }
      persistDtQrState({
        csp: url.replace("/", ""),
        entryMode: capturedQuery.from,
        secretKey: ENCRYPT_STORAGE.getItem(SECRET_KEY),
        mid: ENCRYPT_STORAGE.getItem(MID),
        tableNo: ENCRYPT_STORAGE.getItem(TABLE_NO),
      });
      if (String(capturedQuery.from || "").trim().toUpperCase() === "QR") {
        persistQrAuthContext({
          csp: url.replace("/", ""),
          entryMode: capturedQuery.from,
          mid: ENCRYPT_STORAGE.getItem(MID),
        });
      } else {
        clearQrAuthContext();
      }
    };
    if (IdentifyCspInUrl) {
      if (StoreCsp !== url.replace("/", "")) {
        clearCustomerSessionForQrContextChange();
        clearQrAuthContext();
        ENCRYPT_STORAGE_SESSION.clear();
        ENCRYPT_STORAGE.clear();
        await persistCSP();
        await SET_VALUES_FROM_STORE_ON_START();
        applyCapturedQuery();
        this.setState({ IsReady: true });
        return;
      }
      await persistCSP();
    }
    if (!IdentifyCspInUrl) {
      if (await GET_SET_STORED_DATA()) {
        applyCapturedQuery();
        this.setState({ IsReady: true });
      }
    } else {
      await CLEAR_STORE();
      await persistCSP();
      await SET_VALUES_FROM_STORE_ON_START();
      applyCapturedQuery();
      this.setState({ IsReady: true });
    }
  }

  async storageChange(event) {
    if (
      event.key === "@D_A_I_T_O_N_N:" + STORE_Cart ||
      event.key === "@D_A_I_T_O_N_N:" + STORE_CSID
    ) {
      GET_CART_COUNT();
      let x = window.location.pathname.includes("cart");
      if (x === true) {
        window.location.reload();
      }
    }
  }

  render() {
    return (
      <>
        {this.state.IsReady ? (
          <Routes key={KEY_GENERATOR()}>
            {HomeStack}
            {CartStack}
            {OrdersStack}
            {ProfileStack}
            {GroceryStack}
          </Routes>
        ) : null}
      </>
    );
  }
}
